export const PLACES_API_KEY = 'AIzaSyAws2lDemP0e8d03Z26sHQycbWF7Q6LbGE';



// WEBPACK FOOTER //
// ./resources/assets/js/config.js